import Image, { StaticImageData } from 'next/image';
import logoPng from './images/log.png';
import logo_white from './images/logo-white.png';

export const Logo = ({
  type = 'white',
  className = 'w-[120px]',
  src,
}: {
  type?: 'white' | 'transparent';
  className?: string;
  src?: string | StaticImageData;
}) => {
  const logo = type === 'transparent' ? logo_white : logoPng;
  return (
    <Image
      alt="ssv图标"
      src={src ?? logo}
      width={240}
      height={60}
      className={className}
    />
  );
};
